__turbopack_context__.v({
  "confirming": "InteractiveTipBuzzButton-module-scss-module__1CmWuW__confirming",
  "fillEffect": "InteractiveTipBuzzButton-module-scss-module__1CmWuW__fillEffect",
  "popoverContent": "InteractiveTipBuzzButton-module-scss-module__1CmWuW__popoverContent",
  "tipAmount": "InteractiveTipBuzzButton-module-scss-module__1CmWuW__tipAmount",
});
